import React, { useEffect, useState } from "react";
import { Form, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { createDataReq, } from "../requests";
import { Commons, Const } from "../../constants";
import CreatePolicySlab from "@mods/common/CreatePolicySlab";
import UpdatePolicySlab from "@mods/common/UpdatePolicySlab";
import ViewPolicySlabList from "@mods/common//ViewPolicySlabList";
import { createSelectList } from '@comps/commonFunctions';
const langKey = Const["leavePolicy"].lngKey
const formName = "leavePolicy";

const CreateLeavePolicy = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [deductionTypes, setDeductionTypes] = useState([])
  const [repeats, setRepeats] = useState([])
  const [dataSource, setDataSource] = useState([])
  const [childComponent, setChildComponent] = useState(null)
  const [form] = Form.useForm()
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    setDeductionTypes(createSelectList(props.allData.deduction_types))
    setRepeats(createSelectList(props.allData.repeats))
  }

  const onSubmit = (data) => {
    if (data.slabs === undefined || data.slabs.length < 1) {
      message.info('Please Add Slabs For Policy!')
      return;
    }

    const payload = {
      leave_policy:
      {
        ...data,
        company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    message.success(res.message);
    props.onCompleted(data.leave_policys.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
  }

  // ==================================slabs actions =================================
  const onCreateSlab = () => {
    setChildComponent(<CreatePolicySlab onCompleted={ onCompleted } policyType='leave' allData={ props.allData } fields={ slabFields } />)
  }

  //edit slab
  const onEdit = (key) => {
    const record = form.getFieldValue(`slabs`)[key];
    setChildComponent(<UpdatePolicySlab onCompleted={ onCompleted } allData={ props.allData } record={ { ...record, key: key } } disabled={ false } fields={ slabFields } />)
  };
  //set deleted rows
  const setRows = (key, state) => {

  }
  //on submit slabs
  const onCompleted = (data, action) => {

    let listArray = form.getFieldValue('slabs');
    if (listArray === undefined) {
      listArray = []
    }
    if (data && action === 'Added') {
      listArray.push(data)
      form.setFieldValue('slabs', listArray)
      setDataSource(listArray)
    }
    if (data && action === 'Updated') {

      listArray[data.key] = data
      form.setFieldValue('slabs', listArray)
      setDataSource(listArray)
    }
    setChildComponent(null)
  }

  const slabFields = [
    {
      name: 'min_times',
      label: 'Text Field',
      type: 'number',
      rules: '',
      langkey: 'leave_min_days',
    },
    {
      name: 'max_times',
      label: 'Text Field',
      type: 'number',
      rules: '',
      langkey: 'leave_max_days',
    },
    {
      name: 'repeat_id',
      label: 'Select Field',
      type: 'select',
      options: repeats,
      rules: [],
      langkey: 'repeat_id',
    },
    {
      name: 'deduction_type_id',
      label: 'Select Field',
      type: 'select',
      options: deductionTypes,
      rules: [],
      langkey: 'deduction_type_id',
    },
    {
      name: 'fallback_type_id',
      label: 'Select Field',
      type: 'select',
      options: deductionTypes,
      rules: [],
      langkey: 'fallback_type_id',
    },

    // Add more field configurations as needed
  ];
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form }>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ trans(Commons.name) }
              className="da-mb-16"
            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="description" rules={ rules.description } label={ trans(Commons.description) }
              className="da-mb-16"
            >
              <InputTextArea placeholder={ trans(`${langKey}.description`) } />
            </Form.Item>
          </Col>
        </Row>

        <div className="formlist-container">
          <h5 className="formlist-title">{ trans(Commons.slabs) }</h5>
          <ViewPolicySlabList setRows={ setRows } onCreate={ onCreateSlab } onEdit={ onEdit } fields={ slabFields } />
        </div>
      </Form>

    </ModalComponent>
  )
}

export default CreateLeavePolicy

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.required`) },
  ],
  type: [
    { required: true, message: trans(`${langKey}.type.required`) },
  ],
  value: [
    { required: true, message: trans(`${langKey}.value.required`) },
  ],
  formula_id: [
    { required: true, message: trans(`${langKey}.formula_id.required`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
